<div class="row sale4allStyle1" style="width: 100%; margin-bottom: 1em; margin-top: 1em;">
    <div class="col-10">
        <lable class="labelElm"><b>{{question.label}}</b></lable>
    </div>
    <div class="col-2">
        <input [ngModel]="question.value" disabled type="checkbox" [ngClass]="question.value ? 'custom-checkbox custom-checkbox-v' : 'custom-checkbox custom-checkbox-x'">
    </div>
</div>